/**
 * @param {Object} payload
 * @returns {URLSearchParams}
 */
const getUrlParamsFromArrays = (payload = {}) => {
  const urlParams = new URLSearchParams();

  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        value.forEach((val) => {
          urlParams.append(key, val);
        });
      } else {
        urlParams.append(key, value);
      }
    }
  });

  return urlParams;
};
export default getUrlParamsFromArrays;
